import { List } from '@material-ui/core';
import {
  CircularProgress,
  Container,
  Dialog,
  Grid,
  ListItem,
  ListItemIcon,
  ListItemText,
  Stack
} from '@mui/material';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import CryptoJS from 'crypto-js';
import * as React from 'react';
import { useEffect } from 'react';
import { BsFileEarmarkCheckFill } from 'react-icons/bs';
import { Link } from 'react-router-dom';

import useApiServices from '../services/useApiServices';

import { globalAdminUrl } from '../services/globalApi';

const params = new URL(window.location.href).searchParams;

const userToken = params.get('u');
const companyToken = params.get('c');
const appToken = params.get('a');
const userId = params.get('ui');
const loanId = params.get('li');
const loanTypeid = params.get('lti');

localStorage.setItem('e13ee06b-72e6-4581-86a3-c0a465e63d74', userToken);
localStorage.setItem('e13ee06b-72e6-4581-86a3-c0a465e63d75', companyToken);
localStorage.setItem('e13ee06b-72e6-4581-86a3-c0a465e63d76', appToken);
localStorage.setItem('e13ee06bu-72e6s-4581e-86a3r-c0a465e63d77', userId);
localStorage.setItem('e13ee06bu-72e6s-4581e-86a3r-loanId', loanId);
localStorage.setItem('e13ee06bu-72e6s-4581e-86a3r-loanTypeid', loanTypeid);

function RecommendationConfigure() {
  const { getApi, postApi } = useApiServices();
  // GET FROM APIs
  const [allLoanTypeLists, setAllLoanTypeLists] = React.useState([]);
  const [subLoanTypeList, setSubLoanTypeList] = React.useState([]);
  const [allEmpTypeLists, setAllEmpTypeLists] = React.useState([]);
  const [employmentSubTypeList, setEmploymentSubTypeList] = React.useState([]);
  const [formLoader, setFormLoader] = React.useState(true);
  const [loaderMsg, setLoaderMsg] = React.useState('Loading... Please wait');
  const [salariedOrSelf, setSalariedOrSelf] = React.useState([]);
  const [preferredType, setPreferredType] = React.useState(
    'Select Your Preferred Employment Sub Type:'
  );
  const [token, setToken] = React.useState('');
  const [RefreshComp, setRefreshComp] = React.useState(null);

  const [secondary, setSecondary] = React.useState(false);
  const [employmentType, setEmploymentType] = React.useState('SALARIED_TYPE');
  const [loanSelectType, setLoanSelectType] = React.useState('');
  const [subLoanSelectType, setSubLoanSelectType] = React.useState('');
  const [selectedSubEmpId, setSelectedSubEmpId] = React.useState('');
  const [salariedSelectType, setSalariedSelectType] = React.useState('Salaried_Pay_Slips');
  const [selfEmployedSelectType, setSelfEmployedSelectType] = React.useState(
    'Self_Employed_Proprietorship'
  );

  const [apiCredentials, setApiCredentials] = React.useState({
    companyId: null,
    employmentSubTypeId: null,
    employmentTypeId: null,
    journeyId: null,
    loanSubTypeId: null,
    loanTypeId: null,
    userId: null,
    pageCode: null
  });

  // const [value, setValue] = React.useState(0);

  // const handleChange = (event, newValue) => {
  //   setValue(newValue);
  // };
  const loadSubLoanTypeList = async (parentLoanTypeId) => {
    setLoanSelectType(parentLoanTypeId);
    const companyIdEnc = localStorage.getItem('e13ee06b-72e6-4581-86a3-c0a465e63d75');
    const companyIdx = CryptoJS.AES.decrypt(companyIdEnc, 'companyToken').toString(
      CryptoJS.enc.Utf8
    );
    const pageCode = localStorage.getItem('e13ee06b-72e6-4581-86a3-c0a465e63d74');
    const pageCodeBytes = CryptoJS.AES.decrypt(pageCode, 'userToken');
    const pageCodeText = pageCodeBytes.toString(CryptoJS.enc.Utf8);
    const isLonSubTypeAvailable = await postApi(
      `${globalAdminUrl}/company/loan-masters/list`,
      {
        companyId: companyIdx,
        parentLoanId: parentLoanTypeId.parentLoanId,
        returnConfiguredTypesOnly: true
      },
      pageCodeText
    );
    if (isLonSubTypeAvailable.status === 'success') {
      setSubLoanTypeList(isLonSubTypeAvailable.data.loanTypes);
      setSubLoanSelectType(isLonSubTypeAvailable.data.loanTypes[0]);
    }
  };

  const loadSubEmploymentTypeList = async (employmentCategoryIdx) => {
    setEmploymentType(employmentCategoryIdx);
    const companyIdEnc = localStorage.getItem('e13ee06b-72e6-4581-86a3-c0a465e63d75');
    const companyIdx = CryptoJS.AES.decrypt(companyIdEnc, 'companyToken').toString(
      CryptoJS.enc.Utf8
    );
    const pageCode = localStorage.getItem('e13ee06b-72e6-4581-86a3-c0a465e63d74');
    const pageCodeBytes = CryptoJS.AES.decrypt(pageCode, 'userToken');
    const pageCodeText = pageCodeBytes.toString(CryptoJS.enc.Utf8);
    const isSubEmpList = await postApi(
      `${globalAdminUrl}/company/emp-types/list`,
      {
        companyId: companyIdx,
        employmentCategoryId: employmentCategoryIdx.employmentCategoryId,
        returnConfiguredTypesOnly: true
      },
      pageCodeText
    );
    if (isSubEmpList.status === 'success') {
      setEmploymentSubTypeList(isSubEmpList.data.subEmpTypes);
      setSelectedSubEmpId(isSubEmpList.data.subEmpTypes[0]);
    }
  };

  // const salariedTypes = await getApi(
  //   `${globalAdminUrl}/master/salaried-types`,
  //   pageCodeText
  // );
  // if (salariedTypes.status === 'success') {
  //   salariedTypes.data.salariedTypes.forEach((element) => {
  //     element.imagePath =
  //       element.typeCode === 'SALARIED_CASH'
  //         ? 'static/icons/home/Cash.svg'
  //         : element.typeCode === 'SALARIED_PAY_SLIPS'
  //         ? 'static/icons/home/Payslip.svg'
  //         : '';
  //   });
  //   setSalariedOrSelf(salariedTypes.data.salariedTypes);
  //   setSalariedSelectType(
  //     salariedTypes.data.salariedTypes[0].typeCode
  //   );
  //   const ciphertext = CryptoJS.AES.encrypt(
  //     String(salariedTypes.data.salariedTypes[0].typeId),
  //     'forDocument'
  //   ).toString();
  //   localStorage.setItem(
  //     'e13ee06b-72e6-4581-86a3-employmentSubTypeId',
  //     ciphertext
  //   );
  //   const documentList = await postApi(
  //     `${globalAdminUrl}/customer/documents-checklist`,
  //     {
  //       typeId: salariedTypes.data.salariedTypes[0].typeId,
  //     },
  //     pageCodeText
  //   );

  //   if (documentList.status === 'success') {
  //     setFormLoader(false);
  //     setDocumentList(documentList.data.documentCheckList);
  //   }
  // }

  // let salariedTypes = '';
  // if (empType.typeCode === 'SALARIED_TYPE') {
  //   setPreferredType('Select Your Preferred Salaried Type:');
  //   salariedTypes = await getApi(
  //     `${globalAdminUrl}/master/salaried-types`,
  //     token
  //   );
  // } else {
  //   setPreferredType(
  //     'Select Your Preferred Self Empolyed Type:'
  //   );
  //   salariedTypes = await getApi(
  //     `${globalAdminUrl}/master/self-employed-types`,
  //     token
  //   );
  // }

  // if (salariedTypes.status === 'success') {
  //   salariedTypes.data[
  //     Object.keys(salariedTypes.data)[0]
  //   ].forEach((element) => {
  //     element.imagePath =
  //       element.typeCode === 'SALARIED_CASH'
  //         ? 'static/icons/home/Cash.svg'
  //         : element.typeCode === 'SALARIED_PAY_SLIPS'
  //         ? 'static/icons/home/Payslip.svg'
  //         : element.typeCode === 'SELF_EMPLOYED_PROPRIETORSHIP'
  //         ? 'static/icons/home/proprietorship.svg'
  //         : element.typeCode === 'SELF_EMPLOYED_PARTNERSHIP'
  //         ? 'static/icons/home/Partnership.svg'
  //         : element.typeCode === 'SELF_EMPLOYED_PVT_LTD'
  //         ? 'static/icons/home/Private.svg'
  //         : element.typeCode === 'SELF_EMPLOYED_LLP'
  //         ? 'static/icons/home/LLP.svg'
  //         : '';
  //   });
  //   setSalariedOrSelf(
  //     salariedTypes.data[Object.keys(salariedTypes.data)[0]]
  //   );
  //   setSalariedSelectType(
  //     salariedTypes.data[Object.keys(salariedTypes.data)[0]][0]
  //       .typeCode
  //   );
  //   setRefreshComp(new Date());
  //   const documentList = await postApi(
  //     `${globalAdminUrl}/customer/documents-checklist`,
  //     {
  //       typeId:
  //         salariedTypes.data[
  //           Object.keys(salariedTypes.data)[0]
  //         ][0].typeId,
  //     },
  //     token
  //   );

  //   if (documentList.status === 'success') {
  //     setDocumentList(documentList.data.documentCheckList);
  //   }
  // }
  useEffect(() => {
    const savedApplicationId = localStorage.getItem(`savedApplicationId`);
    const leadIdd = localStorage.getItem('leadId');

    if (savedApplicationId !== null || leadIdd !== null) {
      localStorage.removeItem(`savedApplicationId`);
      localStorage.removeItem('leadId');
    }

    setFormLoader(true);
    setTimeout(() => {
      const pageCode = localStorage.getItem('e13ee06b-72e6-4581-86a3-c0a465e63d74');
      const pageCodeBytes = CryptoJS.AES.decrypt(pageCode, 'userToken');
      const pageCodeText = pageCodeBytes.toString(CryptoJS.enc.Utf8);
      setToken(pageCodeText);

      const companyIdEnc = localStorage.getItem('e13ee06b-72e6-4581-86a3-c0a465e63d75');
      const companyIdx = CryptoJS.AES.decrypt(companyIdEnc, 'companyToken').toString(
        CryptoJS.enc.Utf8
      );

      const userIdEnc = localStorage.getItem('e13ee06bu-72e6s-4581e-86a3r-c0a465e63d77');
      const userIddx = CryptoJS.AES.decrypt(userIdEnc, 'userId').toString(CryptoJS.enc.Utf8);

      setApiCredentials({
        ...apiCredentials,
        companyId: companyIdx,
        userId: userIddx,
        pageCode: pageCodeText
      });

      (async () => {
        const isLonTypeAvailable = await postApi(
          `${globalAdminUrl}/company/parent-loan-masters/list`,
          { companyId: companyIdx, returnConfiguredTypesOnly: true },
          pageCodeText
        );
        if (isLonTypeAvailable.status === 'success') {
          setAllLoanTypeLists(isLonTypeAvailable.data.loanMasters);
          setLoanSelectType(isLonTypeAvailable.data.loanMasters[0]);
          loadSubLoanTypeList(isLonTypeAvailable.data.loanMasters[0]);
        } else {
          setFormLoader(false);
          setLoaderMsg('Your session has been expired. Please generate another Link');
        }
        const isEmpTypeAvailable = await postApi(
          `${globalAdminUrl}/company/parent-emp-types/list`,
          { companyId: companyIdx, returnConfiguredTypesOnly: true },
          pageCodeText
        );
        if (isEmpTypeAvailable.status === 'success') {
          setAllEmpTypeLists(isEmpTypeAvailable.data.empTypes);
          loadSubEmploymentTypeList(isEmpTypeAvailable.data.empTypes[0]);
          setFormLoader(false);
        }
      })();
    }, 1000);
  }, []);

  useEffect(() => {
    setApiCredentials({
      ...apiCredentials,
      loanTypeId: loanSelectType,
      loanSubTypeId: subLoanSelectType,
      employmentTypeId: employmentType,
      employmentSubTypeId: selectedSubEmpId
    });
  }, [loanSelectType, employmentType, selectedSubEmpId, subLoanSelectType]);

  return (
    <Grid item xs="12" sm="6" md="6" mt={4} mb={6}>
      <Container maxWidth="lg">
        <Dialog open={formLoader}>
          <Box
            display="flex"
            width={400}
            height={300}
            justifyContent="center"
            alignItems="center"
            flexDirection="column"
            p={8}
          >
            <CircularProgress />
            <Typography textAlign="center" mt={3}>
              {loaderMsg}
            </Typography>
          </Box>
        </Dialog>
        <Stack>
          <Typography variant="subtitle1" marginBottom={1}>
            Select Your Preferred Loan Type:
          </Typography>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'flex-start',
              flexDirection: 'row',
              marginBottom: '1rem',
              flexWrap: 'wrap'
            }}
          >
            {/* Fresh Home Loan tab  */}
            {allLoanTypeLists &&
              allLoanTypeLists.map((loanType, loanTypeIndex) => (
                <Box
                  key={loanType.loanId}
                  px={2}
                  py={1.5}
                  marginRight={3}
                  marginBottom={1}
                  borderRadius={1}
                  className={
                    loanSelectType.parentLoanId === loanType.parentLoanId
                      ? 'LoanTypeCard active'
                      : 'LoanTypeCard'
                  }
                  onClick={(e) => {
                    loadSubLoanTypeList(loanType);
                    const prevState = apiCredentials;
                    prevState.loanTypeId = loanType;
                    setApiCredentials(prevState);
                  }}
                >
                  <img src={loanType.iconPath} alt="icon" className="LoanTypeIcon" />
                  <Typography variant="body1" className="LoanTypeTitle">
                    {loanType.parentLoanName}
                  </Typography>
                </Box>
              ))}
          </Box>
          <Typography variant="subtitle1" marginBottom={1}>
            Select Your Preferred Loan Sub Type:
          </Typography>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'flex-start',
              flexDirection: 'row',
              marginBottom: '1rem',
              flexWrap: 'wrap'
            }}
          >
            {/* Fresh Home Loan tab  */}
            {subLoanTypeList &&
              subLoanTypeList.map((subLoanType, loanTypeIndex) => (
                <Box
                  key={subLoanType.loanId}
                  px={2}
                  py={1.5}
                  marginRight={3}
                  marginBottom={1}
                  borderRadius={1}
                  className={
                    subLoanSelectType.loanId === subLoanType.loanId
                      ? 'LoanTypeCard active'
                      : 'LoanTypeCard'
                  }
                  onClick={(e) => {
                    setSubLoanSelectType(subLoanType);
                    const prevState = apiCredentials;
                    prevState.loanSubTypeId = subLoanType;
                    setApiCredentials(prevState);
                    // loadSubLoanTypeList(loanType.parentLoanId);
                  }}
                >
                  <img src={subLoanType.iconPath} alt="icon" className="LoanTypeIcon" />
                  <Typography variant="body1" className="LoanTypeTitle">
                    {subLoanType.loanName}
                  </Typography>
                </Box>
              ))}
          </Box>
          <Typography variant="subtitle1" marginBottom={2}>
            Select Your Preferred Employment Type:
          </Typography>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'flex-start',
              flexDirection: 'row',
              marginBottom: '1rem'
            }}
          >
            {/* Salaried Tab */}
            {allEmpTypeLists &&
              allEmpTypeLists.map((empType, empTypeIndex) => (
                <Box
                  px={2}
                  py={1.5}
                  marginRight={3}
                  marginBottom={1}
                  borderRadius={1}
                  className={
                    empType.employmentCategoryId === employmentType.employmentCategoryId
                      ? 'LoanTypeCard active'
                      : 'LoanTypeCard'
                  }
                  onClick={async (e) => {
                    loadSubEmploymentTypeList(empType);

                    const prevState = apiCredentials;
                    prevState.employmentTypeId = empType;
                    setApiCredentials(prevState);
                  }}
                >
                  <img
                    src={empType.employmentCategoryCustomLogo}
                    alt="icon"
                    className="LoanTypeIcon"
                  />
                  <Typography variant="body1" className="LoanTypeTitle">
                    {empType.employmentCategoryName}
                  </Typography>
                </Box>
              ))}
          </Box>

          <Typography variant="subtitle1" marginBottom={3}>
            {preferredType}
          </Typography>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'flex-start',
              flexDirection: 'row',
              marginBottom: '1rem'
            }}
          >
            {employmentSubTypeList &&
              employmentSubTypeList.map((subEmpType, empTypeIndex) => (
                <Box
                  px={2}
                  py={1.5}
                  marginRight={3}
                  marginBottom={1}
                  borderRadius={1}
                  className={
                    subEmpType.employmentSubcategoryId === selectedSubEmpId.employmentSubcategoryId
                      ? 'LoanTypeCard active'
                      : 'LoanTypeCard'
                  }
                  onClick={async (e) => {
                    setSelectedSubEmpId(subEmpType);
                    const prevState = apiCredentials;
                    prevState.employmentSubTypeId = subEmpType;
                    setApiCredentials(prevState);
                  }}
                >
                  <img
                    src={subEmpType.employmentSubcategoryCustomLogo}
                    alt="icon"
                    className="LoanTypeIcon"
                  />
                  <Typography variant="body1" className="LoanTypeTitle">
                    {subEmpType.employmentSubcategoryName}
                  </Typography>
                </Box>
              ))}
          </Box>
          <Box paddingTop="1.5rem">
            <Link
              to={`/recommendation/recommendation-application?${params}`}
              onClick={() => {
                localStorage.setItem('apiCredentials', JSON.stringify(apiCredentials));
                localStorage.removeItem('savedApplicationId');
              }}
              className="mainBtn"
            >
              Yes I Am Ready
            </Link>
          </Box>
        </Stack>
      </Container>
    </Grid>
  );
}

export default RecommendationConfigure;
